module.exports = __webpack_public_path__ + "static/media/tour-mobile-1.c547cd49.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/tour-mobile-1.mp4
// module id = 300
// module chunks = 0